/** @jsx jsx */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx } from '@emotion/core';
import { Typography } from '@material-ui/core';

import { getChallengePhase } from 'core/utils/challenges.helpers';
import { getFormatedDates } from 'core/utils/date.helpers';
import { ChallengeDatesType } from 'interfaces';
import { CHALLENGE_PHASE } from 'constants/index';

export default function ActionPeriod({
  className,
  minified,
  startDate,
  endDate,
}: {
  className?: string;
  minified?: boolean;
  startDate: string;
  endDate?: string | null;
}): JSX.Element {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const actionPeriod = useMemo(() => {
    const dates: ChallengeDatesType = getFormatedDates(
      {
        challenge: {
          start: startDate,
          end: endDate,
        },
      },
      { day: 'numeric', month: 'short', year: 'numeric' },
      language,
    );
    const currentChallengePhase = getChallengePhase(dates);

    if (currentChallengePhase === CHALLENGE_PHASE.AFTER_CHALLENGE) {
      return t('challenges.declaration.history.time.ended', {
        to: dates.challenge.end.string,
      });
    }

    const heading = `${minified ? '' : `${t('common.inProgress')} `}`;
    const period = dates.challenge.end
      ? t('challenges.declaration.history.time.from_to', {
          from: dates.challenge.start.string,
          to: dates.challenge.end.string,
        })
      : t('challenges.declaration.history.time.from', {
          from: dates.challenge.start.string,
        });

    return `${heading}${period}`;
  }, [minified, startDate, endDate, t, language]);

  return (
    <Typography
      className={className}
      css={{ '&:first-letter': { textTransform: 'capitalize' } }}
      dangerouslySetInnerHTML={{ __html: actionPeriod }}
    />
  );
}

ActionPeriod.defaultProps = {
  minified: false,
};
